module.exports = {
  // api key
  apikey: 'AAA-BBB-CCC-DDD',
  backEndBaseUrl: 'https://bo.t365.io',
  frontEndUrl: 'https://bo.t365.io',  
  captchaSiteKey: "6LcbNXkUAAAAAGM_mQWMao2Inp87HUg6FMbBDJd0",
  merchant: "trustbucks"
};
